import { collection, doc, getDoc, where } from "@firebase/firestore";
import { db } from "../../../firebase";

const GetSingleAttendance = async (AttendanceID) => {
  try {
    const AttendanceCollection = collection(db, "Attendance");
    const AttendanceDocument = doc(AttendanceCollection, AttendanceID);
    const AttendanceSnapshot = await getDoc(
      AttendanceDocument,
      where("IsDeleted", "==", false)
    );

    const Attendance = {
      ...AttendanceSnapshot.data(),
      id: AttendanceSnapshot.id,
    };

    return Attendance;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleAttendance;
